import React from 'react';

import './WpBadgeList.scss';

export interface Props {
  children: React.ReactNode;
}

const WpBadgeList: React.FC<Props> = ({ children }: Props) => {
  const classNamePrefix = 'WpBadgeList';
  return <div className={classNamePrefix}>{children}</div>;
};

export default WpBadgeList;
